/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NamespaceRead } from '../models/NamespaceRead';
import type { PeriodTypeEnum } from '../models/PeriodTypeEnum';
import type { UpdateNamespacePayload } from '../models/UpdateNamespacePayload';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class NamespacesService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get Namespace
     * @param namespaceId
     * @returns NamespaceRead Successful Response
     * @throws ApiError
     */
    public getNamespace(
        namespaceId: string,
    ): CancelablePromise<NamespaceRead> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/namespaces/{namespace_id}/get-namespace',
            path: {
                'namespace_id': namespaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Namespace
     * @param namespaceId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public updateNamespace(
        namespaceId: string,
        requestBody: UpdateNamespacePayload,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/namespaces/{namespace_id}/update-namespace',
            path: {
                'namespace_id': namespaceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Namespace
     * @param namespaceId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteNamespace(
        namespaceId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/namespaces/{namespace_id}/delete-namespace',
            path: {
                'namespace_id': namespaceId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Track Period For Namespace
     * @param namespaceId
     * @param clusterId
     * @param periodType
     * @returns any Successful Response
     * @throws ApiError
     */
    public trackPeriodForNamespace(
        namespaceId: string,
        clusterId: any,
        periodType: PeriodTypeEnum,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/namespaces/{namespace_id}/track-period-for-namespace',
            path: {
                'namespace_id': namespaceId,
            },
            query: {
                'cluster_id': clusterId,
                'period_type': periodType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
